export default __webpack_public_path__ + "static/media/coffees.9cd245a2.svg";